import isStandaloneDisplay from '@Infra/Display/isStandaloneDisplay';

/** `true` when the application runs as an installed PWA rather than in a browser tab. */
const isInstalledApplication = (): boolean => {
	return isStandaloneDisplay();
};

export default isInstalledApplication;
